import { useState } from 'react'

import { useFetch } from '@reveni-io/reveni-ui'

import returnsServices from '@/returns/services/services'

import { buildDeclineOnHoldPayload } from './helpers'
import { transformRequestDeclineOnHoldReturn } from './transformers'

const useOnHold = ({ returnId, fetchData, fetchTimeline, setToastInfo }) => {
  const [showDeclineOnHoldDrawer, setShowDeclineOnHoldDrawer] = useState(false)
  const [declineReason, setDeclineReason] = useState('')

  const { fetchData: acceptOnHold, loading: acceptingOnHold } = useFetch(returnsServices.acceptOnHoldReturn, {
    doInitialRequest: false,
  })

  const { fetchData: declineOnHold, loading: decliningOnHold } = useFetch(returnsServices.rejectOnHoldReturn, {
    doInitialRequest: false,
    transformRequest: transformRequestDeclineOnHoldReturn,
  })

  const openDeclineOnHoldDrawer = () => setShowDeclineOnHoldDrawer(true)

  const closeDeclineOnHoldDrawer = () => {
    setShowDeclineOnHoldDrawer(false)
    setDeclineReason('')
  }

  const handleOnAcceptOnHold = async () => {
    try {
      await acceptOnHold({ returnId })
      fetchData()
      fetchTimeline()
    } catch (error) {
      setToastInfo({ show: true, message: error.errorMessage, type: 'error' })
    }
  }

  const handleOnDeclineOnHold = async () => {
    try {
      await declineOnHold({ returnId, payload: buildDeclineOnHoldPayload(declineReason) })

      closeDeclineOnHoldDrawer()
      fetchData()
      fetchTimeline()
    } catch (error) {
      setToastInfo({ show: true, message: error.errorMessage, type: 'error' })
    }
  }

  return {
    handleOnAcceptOnHold,
    handleOnDeclineOnHold,
    acceptingOnHold,
    decliningOnHold,
    showDeclineOnHoldDrawer,
    openDeclineOnHoldDrawer,
    closeDeclineOnHoldDrawer,
    declineReason,
    setDeclineReason,
  }
}

export default useOnHold
